/*---------------------------------------------------------------------------------------------
 *  Copyright (c) by Solusek Systems. All rights reserved.
 *--------------------------------------------------------------------------------------------*/

import React, { Component } from 'react';
import { Outlet } from 'react-router-dom';
import ScrollToTop from './ScrollToTop';

export class Layout extends Component {
  static displayName = Layout.name;

  constructor(props) {
    super(props);
    this.state = {
      showNavbar: false
    };
  }


  render() {
    return (
      <div>
        <ScrollToTop />
        <div className="app-body web-body">
          <Outlet />
        </div>
      </div>
    );
  }
}
